import { ReactComponent as ArrowLeftFile } from 'assets/icons/arrow-left-icon.svg'

import { IconStyles } from '../types'
import { ArrowLeftCustom } from './styles'
interface ArrowLeftProps extends IconStyles {
  onClick?: any
}

const ArrowLeftIcon = ({
  onClick,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  colorIcon
}: ArrowLeftProps) => {
  return (
    <ArrowLeftCustom
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      onClick={onClick}
      colorIcon={colorIcon}
    >
      <ArrowLeftFile />
    </ArrowLeftCustom>
  )
}

export default ArrowLeftIcon
